/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from "react-router-dom";
import ListView from "../../components/common/ListView";
import NoDataFound from "../../components/common/NoDataFound";
import formatDate from "../../utilities/helper";

import {
  IconChevronDown,
  IconChevronLeft,
  IconChevronUp,
  IconEdit,
  IconPrinter,
} from "@tabler/icons-react";
import Pagination from "../../components/common/Pagination";
import { useEffect, useState } from "react";
import { useFetchShippingPartnerManifestDetailsData } from "../../apis/3plApis";
import TableSkeleton from "../../components/skeleton/TableSkeleton";
// import TimelineUI from "./_components/TimelineUI";

const timeLine = [
  { id: 1, label: "New Order" },
  { id: 2, label: "Pickup Generated" },
  { id: 3, label: "Ready For Pickup" },
  { id: 4, label: "Pickup Collected" },
  { id: 5, label: "Received In Warehouse" },
  { id: 6, label: "Out for Delivery" },
  { id: 7, label: "Delivered" },
];

const Section = ({
  title,
  children,
  className,
  mainClassName,
}: {
  title?: string;
  className?: string;
  mainClassName?: string;
  children: React.ReactNode;
}) => (
  <div className="bg-white shadow-sm border border-gray-200 rounded-2xl p-4 sm:p-5 space-y-4">
    {children}
  </div>
);

const ShippingManifiestViewDetail = () => {
  const TwoCol = ({
    label,
    value,
    className,
  }: {
    label: string;
    value: React.ReactNode;
    className?: string;
  }) => (
    <div className="text-sm text-[#1E293B] flex justify-between items-center gap-1 border-b py-3 last:border-0 px-4 ">
      <p className="font-medium text-[#212121] capitalize">{label}:</p>
      <p> {value}</p>
    </div>
  );

  const [openSection, setOpenSection] = useState<string | null>(
    "3PlRequestDetails",
  );
  const toggleSection = (section: string) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };

  const navigate = useNavigate();
  const { id } = useParams<{ id: any }>();

  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const {
    data: pickupData,
    refetch,
    isFetching,
    isLoading,
  } = useFetchShippingPartnerManifestDetailsData(id ?? "");

  useEffect(() => {
    refetch();
  }, [pageNo, limit]);

  return (
    <>
      <div className="p-4 pt-0 space-y-4">
        {/* Header */}
        <div className="flex flex-wrap gap-3 justify-between items-center bg-white p-3 sm:p-4 rounded-xl shadow-sm border">
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate(-1)}
              className="p-1.5 border border-[#D2D2D2] rounded-full hover:bg-[#F7F6F2] transition"
            >
              <IconChevronLeft strokeWidth={1.5} size={22} />
            </button>
            <div className="flex items-center gap-2">
              <h1 className="text-xl text-[#212121] tracking-[-0.5px]  ">
                View Request: {pickupData?.shortId}
              </h1>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1  gap-6 w-full">
          {/* <TimelineUI steps={timeLine} currentStep={3} /> */}
          <Section>
            <div
              onClick={() => toggleSection("3PlRequestDetails")}
              className="flex justify-between items-center cursor-pointer"
            >
              <h2 className="text-lg font-semibold mb-4 text-gray-800">
                3PL Request Details
              </h2>
              <button className="p-2 border rounded-full hover:bg-gray-100 transition">
                {openSection === "3PlRequestDetails" ? (
                  <IconChevronUp size={22} stroke={1.5} color="#6B7280" />
                ) : (
                  <IconChevronDown size={22} stroke={1.5} color="#6B7280" />
                )}
              </button>
            </div>
            {openSection === "3PlRequestDetails" && (
              <div className="grid grid-cols-3 gap-4 ">
                <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden">
                  <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                    3Pl Company Details
                  </h3>
                  <TwoCol
                    label="Company Name"
                    value={pickupData?.companyName}
                  />
                  <TwoCol label="Vehicle" value={pickupData?.vehicleName} />
                  <TwoCol label="Created By" value={pickupData?.createdBy} />
                </div>

                <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden">
                  <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                    Shipment Details
                  </h3>
                  <TwoCol
                    className="col-span-1"
                    label="No. of Packages"
                    value={pickupData?.shipmentCount}
                  />

                  <TwoCol label="Notes" value="Contains glass items" />
                  <TwoCol
                    label="Date"
                    value={formatDate(pickupData?.createdAt)}
                  />
                </div>

                {(pickupData?.status === "ASSIGNED" ||
                  pickupData?.status === "COMPLETED" ||
                  pickupData?.status === "PENDING") && (
                  <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden">
                    <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                      Driver Details
                    </h3>
                    <TwoCol
                      label="Driver Name"
                      value={pickupData?.driverName}
                    />
                    <TwoCol
                      label="Driver Code"
                      value={pickupData?.driverCode}
                    />
                    <TwoCol
                      label="Driver Mobile"
                      value={pickupData?.driverMobileNo}
                    />
                  </div>
                )}

                {(pickupData?.status === "COMPLETED" ||
                  pickupData?.status === "PENDING") && (
                  <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden ">
                    <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                      RIW Details
                    </h3>
                    <TwoCol
                      label="Warehouse Name"
                      value={pickupData?.toWarehouse}
                    />
                    <TwoCol
                      label="Received By"
                      value={pickupData?.assignedStaff}
                    />

                    <TwoCol
                      label="Numbers of Shipments"
                      value={pickupData?.totalShipmentCount}
                    />
                    <TwoCol
                      label="Received"
                      value={pickupData?.verifiedShipmentsCount}
                    />
                    <TwoCol
                      label="Missing"
                      value={pickupData?.missingShipmentsCount}
                    />
                    <TwoCol
                      label="Damage"
                      value={pickupData?.damageShipmentsCount}
                    />
                  </div>
                )}
              </div>
            )}
          </Section>

          <Section>
            <div
              onClick={() => toggleSection("3PlShipmentLists")}
              className="flex justify-between items-center cursor-pointer"
            >
              <h2 className="text-lg font-semibold mb-4 text-gray-800">
                3PL Shipment Lists
              </h2>
              <button className="p-2 border rounded-full hover:bg-gray-100 transition">
                {openSection === "3PlShipmentLists" ? (
                  <IconChevronUp size={22} stroke={1.5} color="#6B7280" />
                ) : (
                  <IconChevronDown size={22} stroke={1.5} color="#6B7280" />
                )}
              </button>
            </div>
            {openSection === "3PlShipmentLists" && (
              <>
                <div className="border rounded-3xl w-full col-span-2 overflow-hidden">
                  <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4  ">
                    Shipments ({pickupData?.shipmentCount})
                  </h3>

                  {isLoading || isFetching ? (
                    <div className="">
                      <TableSkeleton
                        rows={6}
                        columns={["AWB", "Origin", "Destination", "Status"]}
                      />
                    </div>
                  ) : pickupData?.shipments?.length > 0 ? (
                    <ListView
                      mailDivClassName="w-full cols-span-2  p-0    "
                      mainDivClassName=""
                      trClassName="hover:bg-[#FBD037]/20 group"
                      tdClassName="rounded-r-none rounded-l-none"
                      data={pickupData?.shipments}
                      onRowClick={(client) => console.log("Clicked:", client)}
                      columns={[
                        { label: "AWB", render: (c: any) => c.awbNumber },
                        { label: "Origin", render: (c: any) => c.senderCity },
                        {
                          label: "Destination",
                          children: [
                            {
                              label: "Country",
                              render: (c: any) => c.receiverCountry,
                            },
                            {
                              label: "City",
                              render: (c: any) => c.receiverCity,
                            },
                            {
                              label: "District",
                              render: (c: any) => c.receiverDistrict,
                            },
                          ],
                        },
                        {
                          label: "Status",
                          render: (c) => {
                            const getStatusClasses = (status: string) => {
                              switch (status) {
                                case "Out for delivery":
                                case "Dispatch":
                                  return "bg-[#EBF7CE] text-[#212121] border border-[#C6E59D]";
                                case "Delivered":
                                  return "bg-[#EEEEEE] text-[#212121] border border-[#CFCFCF]";
                                case "Undelivered":
                                  return "bg-[#F7E9CE] text-[#212121] border border-[#E6C98A]";
                                default:
                                  return "bg-[#EEEEEE] border border-[#d2d2d2] text-[#212121]";
                              }
                            };
                            const formattedStatus = c.status
                              .toLowerCase()
                              .replace(/_/g, " ")
                              .replace(/\b\w/g, (char: string) =>
                                char.toUpperCase(),
                              );
                            return (
                              <div className="flex justify-center items-center">
                                <button
                                  className={`rounded-full px-4 py-1 text-center ${getStatusClasses(
                                    c.status,
                                  )}`}
                                >
                                  {formattedStatus}
                                </button>
                              </div>
                            );
                          },
                        },
                      ]}
                    />
                  ) : (
                    <NoDataFound />
                  )}
                </div>
                {pickupData?.totalPages > 1 && (
                  <div className="flex justify-center py-4">
                    <Pagination
                      totalPages={pickupData?.totalPages}
                      currentPage={pageNo}
                      fetchData={handlePaginationFetch}
                    />
                  </div>
                )}
              </>
            )}
          </Section>
        </div>
      </div>
    </>
  );
};

export default ShippingManifiestViewDetail;
